import axios from 'axios'
import store from '../store'
import { UNAUTHORIZE } from '../modules/auth'
import _ from 'lodash'

export const request = (url, options = {}) => {
    return new Promise((resolve, reject) => {
        axios({
            url,
            withCredentials: true,
            ...options
        })
            .then(response => {
                if (!_.includes(response.headers['content-type'], 'application')) {
                    throw response
                }

                resolve(response)
            })
            .catch(error => {
                reject(error)

                if (error.response) {
                    // message.error(`${error.response.statusText} (${error.response.status})`)

                    if (error.response.status === 401) {
                        store.dispatch({ type: UNAUTHORIZE })
                    }
                }
            })
    })
}



// WEBPACK FOOTER //
// ./src/utils/http.js